<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图" />
    </div>
    <p class="title">重庆雅南生物技术有限公司</p>
    <p class="address_tel_fax">
      <span
        >地址：重庆市南岸区米兰路17号（吊1层编为米兰路17号附1至附10号）</span
      >
      <span>Tel：023-62483690</span>
    </p>
    <p class="email_wx">
      <span>zhongxueyun2021@163.com</span>
      <span>微信号：17338341676</span>
    </p>
    <!-- <p class="copy">Copyright &copy; 2015 - {{ new Date().getFullYear() }} 重庆雅南生物技术有限公司 渝ICP备20003234号-1</p> -->
    <div class="copy">
      Copyright &copy; 2015 -
      {{ new Date().getFullYear() }} 重庆雅南生物技术有限公司&nbsp;&nbsp;
      <a href="https://beian.miit.gov.cn" target="_blank"
        >渝ICP备20003234号-1</a
      >

      <div style="display: inline-flex; align-items: center; justify-content: center; vertical-align:center">
        &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <img
        src="@/assets/img/beiangov.png"
        alt="logo图"
        style="width: 15px; height: 15px;margin-right: 10px;"
      />
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=50010802005693"
        rel="noreferrer"
        target="_blank"
        >渝公网安备50010802005693</a
      >
    </div>
    </div>

   
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #071621;
  overflow: hidden;
  text-align: center;
}
.logo {
  /* width: 75px; */
  /* height: 35px; */
  /* margin: 50px auto 20px; */
}
.logo img {
  /* width: 55px; */
  height: 85px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
  line-height: 20px;
  text-align: center;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue